import { auth } from "../types"

function logout() {
	return {
		type: auth.LOGOUT,
	}
}

export default logout
